<template>
    <div class="auth-ambient" :style="tokenOverrides">
        <div class="auth-backdrop">
            <svg viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice">
                <g opacity=".16">
                    <polyline class="auth-chartline"
                              points="0,700 130,640 260,668 390,560 520,596 680,470 840,510 1000,420 1180,450 1440,340"
                              fill="none" stroke="var(--auth-accent)" stroke-width="2.5"/>
                    <polyline class="auth-chartline l2"
                              points="0,760 180,730 340,748 500,690 660,706 860,640 1060,660 1440,560"
                              fill="none" stroke="var(--auth-font)" stroke-width="1.5" opacity=".45"/>
                    <g fill="#16344c">
                        <rect x="90" y="560" width="16" height="140"/><rect x="210" y="600" width="16" height="100"/>
                        <rect x="330" y="520" width="16" height="180"/><rect x="450" y="580" width="16" height="120"/>
                        <rect x="570" y="480" width="16" height="220"/><rect x="690" y="540" width="16" height="160"/>
                        <rect x="810" y="450" width="16" height="250"/><rect x="930" y="510" width="16" height="190"/>
                        <rect x="1050" y="430" width="16" height="270"/><rect x="1170" y="490" width="16" height="210"/>
                        <rect x="1290" y="410" width="16" height="290"/>
                    </g>
                </g>
            </svg>
            <div class="auth-glow"></div>
        </div>
        <AuthTicker class="auth-ticker-pos"/>
    </div>
</template>

<script>
import AuthTicker from "@/components/Auth/AuthTicker"
import {authTokenOverrides} from "@/common/auth-theme"

// App-level wiring must ALSO bind authTokenOverrides() on the ancestor that carries
// .auth-ambient, or the sibling modals won't receive overrides.
export default {
    name: "AuthShell",
    components: {AuthTicker},
    computed: {
        tokenOverrides() { return authTokenOverrides() },
    },
}
</script>

<style scoped>
.auth-ambient {
    position: fixed;
    inset: 0;
    z-index: 1000; /* below .modal-wrapper's z-index 1080, above the terminal */
    background: var(--auth-bg);
    overflow: hidden;
}

.auth-backdrop, .auth-backdrop svg { position: absolute; inset: 0; width: 100%; height: 100%; }

.auth-chartline {
    stroke-dasharray: 1400;
    stroke-dashoffset: 1400;
    animation: auth-draw 3.2s ease-out forwards;
}
.auth-chartline.l2 { animation-delay: .5s; }
@keyframes auth-draw { to { stroke-dashoffset: 0; } }

.auth-glow {
    position: absolute;
    width: 60vw;
    height: 50vh;
    left: 55%;
    top: 60%;
    background: radial-gradient(closest-side, rgba(34, 211, 238, .10), transparent);
    animation: auth-drift 18s ease-in-out infinite alternate;
}
@keyframes auth-drift {
    from { transform: translate(-6%, -4%); }
    to { transform: translate(6%, 4%); }
}

.auth-ticker-pos { position: absolute; top: 0; left: 0; right: 0; }

@media (prefers-reduced-motion: reduce) {
    .auth-chartline { animation: none; stroke-dashoffset: 0; }
    .auth-glow { animation: none; }
}
</style>
